import { useEffect, useRef, useState } from "react";
import { Button } from "react-bootstrap";
import { AiFillSetting } from "react-icons/ai";
import DynamicAnalysisChartsPanel from "./DynamicAnalysisChartsPanel";
import MapLoadIndicator from "./MapLoadIndicator";

const FRAME_SOURCE = "/map_runtime/compare_frame.html";

function buildFrameUrl() {
  const params = new URLSearchParams({
    side: "dynamic",
    hideShared: "1",
    mode: "dynamic",
  });
  return `${FRAME_SOURCE}?${params.toString()}`;
}

function postToFrame(frameRef, payload) {
  frameRef.current?.contentWindow?.postMessage(
    {
      source: "compare-map-parent",
      ...payload,
    },
    window.location.origin
  );
}

export default function DynamicAnalysisWorkspace() {
  const frameRef = useRef(null);
  const [activeSharedDrawer, setActiveSharedDrawer] = useState("");
  const [chartsData, setChartsData] = useState(null);
  const [mapLoadingState, setMapLoadingState] = useState(null);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.origin !== window.location.origin) return;
      const payload = event.data || {};
      if (payload.source !== "compare-map-frame") return;
      if (payload.side !== "dynamic") return;

      if (payload.type === "shared-drawer-visibility") {
        setActiveSharedDrawer(payload.open ? String(payload.drawer || "") : "");
        return;
      }

      if (payload.type === "map-loading-state") {
        setMapLoadingState(payload.state || null);
        return;
      }

      if (payload.type === "dynamic-charts-data") {
        setChartsData(payload.data || null);
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  return (
    <div className={`comparison-workspace${activeSharedDrawer ? " is-shared-open" : ""}`}>
      <div className="comparison-top-left-rail">
        <Button
          variant="dark"
          onClick={() => {
            setActiveSharedDrawer("settings");
            postToFrame(frameRef, { type: "open-drawer", drawer: "settings" });
          }}
          className="buttons_custom_value"
        >
          <AiFillSetting className="icons_custom" /> Настройки
        </Button>

        <DynamicAnalysisChartsPanel data={chartsData} />
        <MapLoadIndicator state={mapLoadingState} />
      </div>

      <div
        className={`comparison-shared-backdrop${activeSharedDrawer ? " is-open" : ""}`}
        onClick={() => {
          setActiveSharedDrawer("");
          postToFrame(frameRef, { type: "close-drawer" });
        }}
      />

      <div className="comparison-grid comparison-grid-single">
        <section className={`comparison-panel comparison-panel-single${activeSharedDrawer ? " is-raised" : ""}`}>
          <iframe
            ref={frameRef}
            title="Карта анализа динамики"
            className="comparison-frame"
            src={buildFrameUrl()}
          />
        </section>
      </div>
    </div>
  );
}
